export { default } from './SkeletonCarRentalContainer';
